export enum ResidenceTypeEnum {
    permanent = 'permanent',
    temporary = 'temporary',
    long = 'long',
}
